<div class="lookup-container">

  <div class="table-wrapper" *ngIf="!loading && records.length > 0">
    <table class="custom-table">
      <thead>
        
        <tr *ngIf="type === 'receivables'">
          <th>Customer Name</th>
          <th>Invoice No</th>
          <th>Due Date</th>
          <th class="text-right">Invoice Amount</th>
          <th>Payment Status</th>
          <th class="text-right">Due Amount</th>
        </tr>

        <tr *ngIf="type === 'payables'">
          <th>Vendor Name</th>
          <th>Bill No</th>
          <th>Due Date</th>
          <th class="text-right">Bill Amount</th>
          <th>Payment Status</th>
          <th class="text-right">Due Amount</th>
        </tr>

      </thead>

      <tbody>
        <tr *ngFor="let record of records"
            (click)="selectRecord(record)"
            class="table-row">

          <ng-container *ngIf="type === 'receivables'">
            
            <td>
              {{ record.customerName || '-' }}
            </td>

            <td>
              {{ record.salesOrderNumber || record.accountReceivableId }}
            </td>

            <td>
              {{ record.dueDate ? (record.dueDate | date:'dd/MM/yy') : '-' }}
            </td>

            <td class="text-right">
              {{ formatINR(record.invoiceAmount) }}
            </td>

                <td>
              {{ record.status }}
              </td>


            <td class="text-right bold"
                [ngClass]="{'due-highlight': record.amountDue > 0}">
              {{ formatINR(record.amountDue) }}
            </td>

          </ng-container>


          <ng-container *ngIf="type === 'payables'">

            <td>
              {{ record.vendorName || '-' }}
            </td>

            <td>
              {{ record.vendorBillCode || record.accountPayableId }}
            </td>

            <td>
              {{ record.dueDate ? (record.dueDate | date:'dd/MM/yy') : '-' }}
            </td>

            <td class="text-right">
              {{ formatINR(record.billAmount) }}
            </td>

            <td>
              {{ record.status }}
          </td>
            <td class="text-right bold"
                [ngClass]="{'due-highlight': record.amountDue > 0}">
              {{ formatINR(record.amountDue) }}
            </td>

          </ng-container>

        </tr>
      </tbody>
    </table>
  </div>


</div>
